import { render, staticRenderFns } from "./DailyImageModal.vue?vue&type=template&id=bedaad32&scoped=true"
import script from "./DailyImageModal.vue?vue&type=script&lang=js"
export * from "./DailyImageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedaad32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bedaad32')) {
      api.createRecord('bedaad32', component.options)
    } else {
      api.reload('bedaad32', component.options)
    }
    module.hot.accept("./DailyImageModal.vue?vue&type=template&id=bedaad32&scoped=true", function () {
      api.rerender('bedaad32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/dailyImage/modules/DailyImageModal.vue"
export default component.exports